import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sklMatch' })

export class MatchPipe implements PipeTransform {
    public transform(value: string | string[], ...args: string[]): string | string[] {

        if (!value) {

            return value;
        }

        const match = (arr: string[]) => arr.filter(item => item.match(new RegExp(`${args}`)));

        return Array.isArray(value) ? match(value) : match(`${value}`.split(',').map(item => item.trim()));
    }
}
